import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { course, weeks, labs } from "@/src/lib/content";
import config from "@/site.config.json";

const publicMeta: Record<string, { title: string; description: string }> = {
  "/": { title: course.course_name, description: course.course_subtitle },
  "/programme": { title: "Programme", description: "Outcomes, assessment, weekly outline, readings, labs, and validation status for the Responsible and Ethical AI microcredential." },
  "/about": { title: "How it is taught", description: "A practitioner-led, accessible, and evidence-centred approach to responsible AI architecture education." },
  "/resources": { title: "Books and resources", description: "Books, open scholarship, frameworks, and responsible access supporting the course." },
  "/notice": { title: "Rights and attribution", description: "Rights, attribution, and responsible reuse for the Responsible Architectures course package." },
};

function ensureMeta(name: string) {
  let node = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.name = name;
    document.head.append(node);
  }
  return node;
}

export function MetaManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const week = weeks.find((entry) => pathname.endsWith(entry.slug));
    const lab = labs.find((entry) => pathname.endsWith(entry.slug));
    const meta = publicMeta[pathname] || (week ? { title: `Week ${week.number}: ${week.title}`, description: week.narrative } : lab ? { title: `Lab ${lab.number}: ${lab.title}`, description: `Applied lab in ${course.course_name}.` } : pathname.startsWith("/course") ? { title: "Enrolled students", description: course.course_subtitle } : { title: "Page not found", description: course.course_subtitle });
    document.title = `${meta.title} | Responsible Architectures`;
    ensureMeta("description").content = meta.description;
    ensureMeta("robots").content = pathname.startsWith("/course") ? "noindex, nofollow, noarchive" : "index, follow";
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.href = `${config.site_url}${pathname === "/" ? "/" : pathname}`;
  }, [pathname]);
  return null;
}
